
import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData, postData, updateData, } from "../../../services/api";
import { hideAddGdprModal } from "./gdprModalDispatcher";



export const adGdprRequest = (data,) => {
  return async (dispatch) => {
    dispatch({ "type": "ADD_GDPR_REQUEST" });
    try {

      var gdprResponse = (data.id) ? await updateData(data, `${ApiURLs.GDPR}/${data.id}`) : await postData(data, ApiURLs.GDPR);
      if (gdprResponse.status === 1) {
        dispatch({ "type": "ADD_GDPR_SUCCESS" });
        dispatch(hideAddGdprModal());
        dispatch(gdprLisitingRequest(data.gdpr_key));
      } else {
        dispatch({ "type": "ADD_GDPR_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_GDPR_FAILED" });

    }
  };
};




export const gdprLisitingRequest = (gdpr_key="gdpr") => {

  return async (dispatch) => {

    const url = `${ApiURLs.GDPR}?gdpr_key=${gdpr_key}`;

    console.log("GDPR:::",url);
    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_GDPR_REQUEST" });
    try {
      var gdprData = await fetchData(url);
      console.log(`response when we try to get gdpr  ${JSON.stringify(gdprData)}`)
      if (gdprData.status === 1) {
        dispatch({ type: "GET_GDPR_REQUEST_SUCCESS", payload: gdprData.data.result });

      } else {
        dispatch({ "type": "GET_GDPR_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_GDPR_REQUEST_FAILED" });
      console.log(`error while try to get gdpr  ${error}`)
    }
  }
};



